import { useAttendancePageContext } from '../Context';

const useAttendanceRouter = () => {
  const { currentScreen } = useAttendancePageContext();

  return { currentScreen };
};

export default useAttendanceRouter;
